module.exports = __webpack_public_path__ + "static/media/y5ANNUEoOT46xtNIAiXFQDcfyIW4fe5dqTSq2F4c.0f6d83bc.webp";